/* Jade v2 · Object (the case opening). How it works: the header of sections/jade-v2-object.liquid. */
(function () {
  'use strict';
  var w = window, d = document, N = 51, NS = 18, NU = 24, SRCW = 540;
  // v5 progress = pin progress * END: every beat keeps its v5 scroll distance (END = --end in the CSS).
  // 4 Oct flow audit: the three still stretches are cut (a hold before the sleeve moves, .035 between the sleeve and the hook, and the
  // settle after the lid); every beat keeps its scroll distance (S1 - S0 = .16, U1 - U0 = .035, L1 - L0 = .165 as before).
  // S0 stays above .016: rest(p) (the frames take over from the stills) needs p < S0 - .016, and p is 0 until the pin starts.
  var END = .453,
    S0 = .02, S1 = .18, // sleeve off: frames 1-18
    U0 = .208, U1 = .243, // hook: 19-24 (U0 - S1 = .028: the two hand-over fades, nothing more)
    L0 = .248, L1 = .413; // lid: 25-51; the pin ends .04 later, on the open bottle

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ss(a, b, p) { var t = clamp((p - a) / (b - a)); return t * t * (3 - 2 * t); }
  // the stage at v5 progress p; still: the cross-fade schedule (no frames)
  function look(p, still) {
    return { s: still ? 1 - ss(S0, S1, p) : 1 - ss(S0 - .014, S0 - .002, p),
      c: still ? ss(S0, S1, p) * (1 - ss(L0, L1, p)) : ss(S1 + .002, S1 + .014, p) * (1 - ss(U0 - .014, U0 - .002, p)),
      o: still ? ss(L0, L1, p) : ss(L1 + .002, L1 + .014, p) };
  }
  function rest(p) { return p < S0 - .016 || p > L1 + .016; }
  function loadOrder(set) { // hand-overs, then midpoints level by level
    var has = {}, q = [], seen = {}, r = [[1, N]], a, b, m;
    function add(f) { if (has[f] && !seen[f]) { seen[f] = 1; q.push(f); } }
    set.forEach(function (f) { has[f] = 1; });
    [1, NS, NS + 1, NU, NU + 1, N].forEach(add);
    while (r.length) { a = r[0][0]; b = r.shift()[1]; m = (a + b) >> 1; if (m > a && m < b) { add(m); add(m + 1); r.push([a, m], [m, b]); } }
    set.forEach(add);
    return q;
  }

  function init() {
    var SSD = w.SSD, root = d.getElementById('d-object'), conn = navigator.connection || {};
    if (!root || root.classList.contains('d-obj--live')) return;
    if (!SSD || SSD.reduced || conn.saveData || !(SSD.animated || d.documentElement.classList.contains('d-anim'))) return;
    function $(s) { return root.querySelector(s); }
    var track = $('.d-obj-track'), stage = $('.d-obj-stage'), win = $('.d-obj-win'), cv = $('.d-obj-cv'),
      st = { s: $('.d-obj-st--sleeve'), c: $('.d-obj-st--closed'), o: $('.d-obj-st--open') },
      ctx = cv && cv.getContext && cv.getContext('2d');
    if (!track || !stage || !win || !ctx || !st.o) return;

    var SRC = [], FR = [], i;
    try { SRC = JSON.parse(d.getElementById('jv2-object-frames').textContent); } catch (e) {}
    var qf = (/[?&]jv2frames=(\d+)/.exec(w.location.search) || [])[1], // QA: 51 | 28
      phone = qf ? qf !== '51' : w.innerWidth < 900 || !!(w.matchMedia && w.matchMedia('(pointer: coarse)').matches),
      fb = /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '') || SRC.length < N || !w.createImageBitmap || !w.fetch,
      SDA = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline: view()') && CSS.supports('animation-range: contain 0% contain 9px'));
    for (i = 1; i <= N; i++) if (!phone || i % 2 || i === NS || i === NU) FR.push(i);

    var W = 0, H = 0, run = 1, top0 = 0, mainW = 0, ps = -1, lastP = -2, idx = 1, raf = 0, near = false, started = false,
      wait = true, opened = false, lastW = w.innerWidth, ph,
      blobs = {}, bmp = {}, pend = {}, q = [], dq = [], dbusy = 0, cur = 0, cache = {}, stat = { n: 0, ms: 0, max: 0 };

    function set(el, key, prop, v) { if (cache[key] !== v) { cache[key] = v; el.style[prop] = v; } }
    function done(m) { if (!opened) { opened = true; if (SSD.track) SSD.track('object_open', { mode: m }); } }
    function measureTop() {
      top0 = track.getBoundingClientRect().top + w.scrollY;
      run = Math.max(1, track.offsetHeight - stage.offsetHeight);
    }
    function measure() {
      W = win.clientWidth; H = win.clientHeight; measureTop();
      var bw = Math.max(1, Math.min(SRCW, Math.round(W * Math.min(2, w.devicePixelRatio || 1)))), bh = Math.round(bw * H / (W || 1));
      if (!fb && (cv.width !== bw || cv.height !== bh)) { cv.width = bw; cv.height = bh; ctx.imageSmoothingQuality = 'low'; cur = 0; } // 'high' stutters on iOS
      cache = {}; lastP = -2;
    }
    function mode(still) { if (still !== wait) { wait = still; root.classList.toggle('d-obj--wait', still); cache = {}; lastP = -2; } }

    function imgs(fn) { [].forEach.call(root.querySelectorAll('.d-obj-img'), fn); }
    // a still paints once decoded (.d-obj--n<s|c|o> until then)
    function readiness() {
      imgs(function (im) {
        var k = im.closest('.d-obj-st'), ok = function () {
          (im.decode ? im.decode() : Promise.resolve()).then(function () { root.classList.remove(k); kick(1); }, function () {});
        };
        if (k) root.classList.add(k = 'd-obj--n' + k.className.split('--')[1][0]);
        if (im.complete && im.naturalWidth) ok(); else im.addEventListener('load', ok, { once: true });
      });
    }
    // one frame per call, for the page's picture queue (SSD.pics); Accept: */* gets a JPEG (section header)
    function one(hi) {
      if (!q.length) return null;
      var i = q.shift();
      return fetch(SRC[i - 1], { priority: hi ? 'high' : 'low', headers: { Accept: 'image/webp,*/*' } }).then(function (r) { if (!r.ok) throw r.status; return r.blob(); })
        .then(function (b) { blobs[i] = b; if (near) decode(i); }, function () { if (i === 1 || i === N) fallback(); });
    }
    function decode(i) { if (!bmp[i] && !pend[i] && blobs[i]) { pend[i] = 1; dq.push(i); dpump(); } }
    function dpump() {
      while (dbusy < 2 && dq.length) (function (i) {
        var t = performance.now(); dbusy++;
        createImageBitmap(blobs[i]).then(function (b) {
          t = performance.now() - t; stat.n++; stat.ms += t; stat.max = Math.max(stat.max, t);
          delete pend[i];
          if (fb || !near || bmp[i]) b.close(); else { bmp[i] = b; kick(1); }
        }, function () { delete pend[i]; }).then(function () { dbusy--; dpump(); });
      })(dq.shift());
    }
    function release() { for (var k in bmp) bmp[k].close(); bmp = {}; pend = {}; dq = []; cur = 0; }
    function nearest(t) { var b = 0, bd = 99, k; for (k in bmp) if (Math.abs(k - t) < bd) { bd = Math.abs(k - t); b = +k; } return b; }
    function fallback() {
      if (fb) return; fb = true;
      root.classList.add('d-obj--fb'); release(); blobs = {}; q = []; cache = {}; kick(1);
    }
    // the stills are the queue's like every picture; the frames join it as a soft feed, behind the stills of the next screens
    function start() {
      if (started || fb) return; started = true;
      q = loadOrder(FR); SSD.pics.feed(track, one, true);
    }
    function frameAt(p) {
      if (p < U0) return 1 + (NS - 1) * clamp((p - S0) / (S1 - S0));
      if (p < L0) return NS + 1 + (NU - NS - 1) * clamp((p - U0) / (U1 - U0));
      return NU + 1 + (N - NU - 1) * clamp((p - L0) / (L1 - L0));
    }
    function layers(p) { // no scroll-driven animations
      var L = look(p, fb || wait), C = root.classList;
      if ((fb || wait) && C.contains('d-obj--no')) { if (C.contains('d-obj--nc')) L.s = 1; else L.c = ss(S0, S1, p); }
      set(st.s, 's', 'opacity', L.s.toFixed(3)); set(st.c, 'c', 'opacity', L.c.toFixed(3)); set(st.o, 'o', 'opacity', L.o.toFixed(3));
    }
    function tick() {
      raf = 0;
      var p = clamp((w.scrollY - top0) / run) * END, t, b;
      if (SDA) ps = p; else { ps = ps < 0 ? p : ps + (p - ps) * .22; if (Math.abs(p - ps) < 2e-4) ps = p; }
      if (ps !== lastP) {
        lastP = ps; idx = frameAt(ps); t = Math.round(idx);
        if (!fb) {
          b = nearest(t);
          if (b && b !== cur) { ctx.drawImage(bmp[b], 0, 0, cv.width, cv.height); cur = b; if (b === N) done('frames'); }
          if (!b || Math.abs(b - t) > 2) mode(true); else if (wait && (rest(ps) || !near)) mode(false);
        }
        if ((fb || wait) && ps >= L1) done('stills');
        if (!SDA) layers(ps);
        if (!ph) root.setAttribute('data-ph', ph = 'on'); // title shows once live
      }
      if (ps !== p) kick();
    }
    function kick(force) { if (force) lastP = -2; if (!raf) raf = requestAnimationFrame(tick); }

    // scroll-driven: the curves sampled once into keyframes
    function keyframes() {
      var M = 1200, F = [], S = [], css = '', k;
      for (k = 0; k <= M; k++) { F.push(look(k / M * END)); S.push(look(k / M * END, 1)); }
      function keep(get, tol) {
        var out = { 0: 1 }, stack = [[0, M]], r, a, b, va, vb, k, j, e, worst, wi, vk;
        out[M] = 1;
        while (stack.length) {
          r = stack.pop(); a = r[0]; b = r[1]; va = get(a); vb = get(b); worst = 1; wi = -1;
          for (k = a + 1; k < b; k++) {
            vk = get(k);
            for (j = 0, e = 0; j < vk.length; j++) e = Math.max(e, Math.abs(vk[j] - va[j] - (vb[j] - va[j]) * (k - a) / (b - a)) / tol[j]);
            if (e > worst) { worst = e; wi = k; }
          }
          if (wi > 0) { out[wi] = 1; stack.push([a, wi], [wi, b]); }
        }
        return Object.keys(out).map(Number).sort(function (x, y) { return x - y; });
      }
      function opf(v) { return 'opacity:' + v[0].toFixed(3); }
      function kf(name, get, tol, fmt) {
        return '@keyframes jv2o-' + name + '{' + keep(get, tol).map(function (k) { return +(k / M * 100).toFixed(3) + '%{' + fmt(get(k)) + '}'; }).join('') + '}';
      }
      ['s', 'c', 'o'].forEach(function (x, n) {
        var name = ['sleeve', 'closed', 'open'][n];
        [[F, '-f'], [S, '-s']].forEach(function (A) {
          css += kf(name + A[1], function (k) { return [A[0][k][x]]; }, [.003], opf);
        });
      });
      css += kf('closed-h', function (k) { return [ss(S0, S1, k / M * END)]; }, [.003], opf);
      k = d.createElement('style'); k.id = 'jv2-object-sda'; k.textContent = css; d.head.appendChild(k);
    }

    function live() {
      if (root.classList.contains('d-obj--live')) return;
      if (SDA) { keyframes(); root.classList.add('d-obj--sda'); }
      if (fb) root.classList.add('d-obj--fb');
      root.classList.add('d-obj--live', 'd-obj--wait');
      readiness(); measure(); tick();
      var main = root.closest('main') || d.body, armed = 0;
      if (w.ResizeObserver) new ResizeObserver(function () {
        var mw = main.clientWidth, t = top0, r = run;
        measureTop(); if (t !== top0 || r !== run) kick(1);
        if (mw !== mainW) { mainW = mw; if (win.clientWidth !== W) { measure(); kick(1); } }
      }).observe(main);
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { measureTop(); kick(1); });
      w.addEventListener('load', function () { measureTop(); kick(1); });
      w.addEventListener('resize', function () {
        if (w.innerWidth !== lastW) { lastW = w.innerWidth; measure(); kick(1); }
      }, { passive: true });
      /* frames only while the section is on screen (4 Oct): near (three screens out) is for decoding; reading scrollY in a rAF while
         the steam and the story were still on screen forced their style recalc early in every frame for nothing. Leaving
         the screen runs one last frame, which settles the clamped end state as before. */
      var vis = !w.IntersectionObserver;
      if (!vis) new IntersectionObserver(function (es) { vis = es[es.length - 1].isIntersecting; kick(); }).observe(root);
      w.addEventListener('scroll', function () { if (near && vis) kick(); }, { passive: true });
      // near: the whole set decoded. No frame 20 s after first near (not after load: a slow reader lost the frames): stills
      new IntersectionObserver(function (es) {
        near = es[0].isIntersecting;
        if (near) { if (!armed++) setTimeout(function () { if (!stat.n) fallback(); }, 20000); if (!fb) FR.forEach(decode); } else release();
        kick(1);
      }, { rootMargin: '300% 0px' }).observe(root);
      start();
      w.__dObj = function (p) { ps = -1; measureTop(); w.scrollTo(0, top0 + p * run); };
      w.__dObjState = function () {
        return { cur: cur, target: Math.round(idx), mode: fb ? 'fb' : wait ? 'wait' : 'frames', sda: SDA, set: FR.length,
          decoded: Object.keys(bmp).length, decodeMs: stat };
      };
    }

    function styled() { return (w.getComputedStyle(root).getPropertyValue('--obj-ground') || '').trim() !== ''; }
    var tries = 0; (function poll() { if (styled()) live(); else if (++tries < 120) setTimeout(poll, 125); })();
  }

  if (w.SSD && w.SSD.onReady) w.SSD.onReady(init);
})();
